import React, { useEffect, useState } from 'react';
import { LifecycleColorMap } from '../constants/lifecycle';
import { IKeyValMap } from '../interfaces/IKeyValMap';
import MetadataService from '../metadata.service';
import { Tag } from './Tag';
/**
 *
 * @param {string} status - Renders a <Tag /> element. Note this is a child
 * of the `<Column />` created by `renderStatusColumn`
 */
export const ApplicationLifecycle = ({ lifecycle }: { lifecycle: string }) => {
  const [applicationLifecycle, setApplicationLifecycle] = useState(
    {} as IKeyValMap,
  );

  useEffect(() => {
    let mounted = true;
    MetadataService.getApplicationLifecycles().then(data => {
      if (mounted) {
        setApplicationLifecycle(data);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (lifecycle in LifecycleColorMap) {
    const label = applicationLifecycle[lifecycle]?.displayText || '';
    return <Tag color={LifecycleColorMap[lifecycle]}>{label}</Tag>;
  }

  // We dont display general lifecycle in v2
  // The mapping above should contains all the value for v1 lifecycle
  // Below line is only needed for development purposes
  return <span>{lifecycle}</span>;
};
